import cx from 'classnames'
import PropTypes from 'prop-types'

import {TYPES} from './dealer-service-config.js'

const CONTENT_TEST_ID = 'content-dealer-service'
const ICON_COLOR = 'currentColor'
const ICON_SIZE_LARGE = 'large'
const ICON_SIZE_MEDIUM = 'medium'

const DealerServiceContent = ({className, description, isIncluded, icon: Icon, service, type}) => {
  const isBrief = type === TYPES.BRIEF
  const isExtended = type === TYPES.EXTENDED
  /**
   * This field is not returned yet from backend. When specifically return false (not undefined),
   * that's when we can actually say that the service is not included.
   */
  const isServiceNotIncluded = isIncluded === false

  const showServiceDescription = description && isExtended

  const serviceTitleClasses = cx(`${className}-serviceTitle`, {
    [`strikethrough`]: isServiceNotIncluded
  })

  return (
    <div className={`${className}-content`} data-testid={CONTENT_TEST_ID}>
      <Icon
        className={`${className}-icon`}
        color={ICON_COLOR}
        {...(isBrief ? {size: ICON_SIZE_LARGE} : {size: ICON_SIZE_MEDIUM})}
      />
      <div className={`${className}-service`}>
        <p className={serviceTitleClasses}>{service}</p>
        {showServiceDescription ? <p className={`${className}-serviceDescription`}>{description}</p> : null}
      </div>
    </div>
  )
}

DealerServiceContent.displayName = 'DealerServiceContent'
DealerServiceContent.propTypes = {
  className: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.elementType.isRequired,
  isIncluded: PropTypes.bool,
  service: PropTypes.string.isRequired,
  type: PropTypes.string
}

export default DealerServiceContent
